import FileSaver from 'file-saver'
import XLSX from 'xlsx'

export default {
  install(Vue, options) {
    Vue.prototype.getHubTemplateExcel = function () {
      // 生成 workbook
      var wb = XLSX.utils.table_to_book(document.querySelector('#hub_template'))

      // 假设数据在第一个 sheet
      const ws = wb.Sheets[wb.SheetNames[0]]
      // 获取表格范围
      const range = XLSX.utils.decode_range(ws['!ref'])
      // 假设第6列（F列）需要保留前导0
      for (let R = range.s.r + 1; R <= range.e.r; ++R) { // 跳过表头
        const cell_address = { c: 5, r: R } // c:5 表示F列
        const cell_ref = XLSX.utils.encode_cell(cell_address)
        const cell = ws[cell_ref]
        if (cell && typeof cell.v === 'number') {
          // 只对正整数补零
          if (Number.isInteger(cell.v) && cell.v >= 0) {
            cell.v = String(cell.v).padStart(3, '0')
          } else {
            cell.v = String(cell.v)
          }
          cell.t = 's'
          cell.z = '@'
          cell.s = { numFmt: '@' }
        } else if (cell && typeof cell.v === 'string') {
          cell.t = 's'
          cell.z = '@'
          cell.s = { numFmt: '@' }
        }
      }

      var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
      try {
        const fileName = `BAM2HUB_${new Date().toISOString().slice(0, 10).replace(/-/g, '')}.xlsx`
        FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), fileName)
      } catch (e) {
        if (typeof console !== 'undefined') console.log('保存文件出错', e, wbout)
      }
      return wbout
    }
  }
}